export class EnhancedProgressTimeout {
  public aliveTimer: any;
  public isDone = false;
  public timeout = 1800000; // 30분으로 증가 (기존 5분)
  public timeoutHandler: (() => void) | null = null;
  public lastProgressTime = Date.now();
  public progressCount = 0;

  constructor(timeout?: number) {
    if (timeout) {
      this.timeout = timeout;
    }
  }

  progress() {
    this.lastProgressTime = Date.now();
    this.progressCount++;
    
    if (this.timeout > 0 && this.timeoutHandler) {
      clearTimeout(this.aliveTimer);
      this.aliveTimer = setTimeout(this.timeoutHandler, this.timeout);
    }
  }

  done() {
    this.isDone = true;
    if (this.aliveTimer) {
      clearTimeout(this.aliveTimer);
    }
  }

  setHandler(handler: () => void) {
    this.timeoutHandler = handler;
  }

  getProgressStats() {
    return {
      progressCount: this.progressCount,
      lastProgressTime: this.lastProgressTime,
      timeSinceLastProgress: Date.now() - this.lastProgressTime,
    };
  }
}

// 파일 크기별 동적 타임아웃 설정 (대용량 100GB까지 고려)
export function getTimeoutForFile(fileSize: number): number {
  const sizeInMB = fileSize / (1024 * 1024);
  const sizeInGB = fileSize / (1024 * 1024 * 1024);
  
  // 소용량 파일 (100MB 미만)
  if (sizeInMB < 100) return 300000;      // 5분
  
  // 중용량 파일 (100MB ~ 1GB)
  if (sizeInMB < 500) return 900000;      // 15분
  if (sizeInMB < 1000) return 1800000;    // 30분
  
  // 대용량 파일 (1GB ~ 10GB)
  if (sizeInGB < 5) return 3600000;       // 1시간
  if (sizeInGB < 10) return 7200000;      // 2시간
  
  // 초대용량 파일 (10GB ~ 50GB)
  if (sizeInGB < 25) return 14400000;     // 4시간
  if (sizeInGB < 50) return 21600000;     // 6시간
  
  // 극대용량 파일 (50GB ~ 100GB)
  if (sizeInGB < 75) return 28800000;     // 8시간
  if (sizeInGB < 100) return 36000000;    // 10시간
  
  // 100GB 이상 (최대 타임아웃)
  return 43200000;                        // 12시간
} 